// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"20783283","732":"c30bc338","977":"40938f6e"}[chunkId] + ".chunk.js";
};